import * as types from './types'

const intitialState = {
    histories: [],
    condFilters: {}
}

const identifyFilterHistoryReducer = (state = intitialState, action) => {
    switch (action.type) {        
        case types.IDENTIFY_FILTER_HISTORY: {
            const { histories, ...payload } = action.payload
            return {
                ...state,
                ...payload,
                // histories: [...state.histories, ...histories],
                histories
            }
        }
        case types.IDENTIFY_FILTER_HISTORY_ERR: {
            return intitialState
        } 
        case types.RESET_IDENTIFY_FILTER_HISTORY: {
            return intitialState
        }     
        default:
            return state;
    }

}

export default identifyFilterHistoryReducer